import { useEffect } from "react";
import { CONST_ROL_MASTER } from "../../../../app/constants/constanst-valores";
import { CONST_CODIGO_USUARIOS_AGREGAR, CONST_CODIGO_USUARIOS_EDITAR, CONST_CODIGO_USUARIOS_ELIMINAR, CONST_CODIGO_USUARIOS_GRUPOS, CONST_CODIGO_USUARIOS_RESETEAR_CONTRASEÑA } from "../../../../app/constants/constants-rutas-codigos";

// Visibilidad de los botones del listado según las rutas de acceso del usuario.
export const useUsuariosPermisosBotones = ({
  listaRutasDeAcceso,
  rol,
  setMostrarBotonAgregar,
  setMostrarBotonEditar,
  setMostrarBotonEliminar,
  setMostrarBotonUsuarioGrupo,
  setMostrarBotonUsuarioResetearContraseña,
}: any) => {
  useEffect(() => {

    const encontradoRutaBotonAgregar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_AGREGAR)
    const encontradoRutaBotonEditar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_EDITAR)
    const encontradoRutaBotonEliminar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_ELIMINAR)
    const encontradoRutaBotonUsuarioGrupo = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_GRUPOS)
    const encontradoRutaBotonUsuarioResetearContraseña = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_RESETEAR_CONTRASEÑA)

    encontradoRutaBotonAgregar ? setMostrarBotonAgregar(true) : setMostrarBotonAgregar(false)
    encontradoRutaBotonEditar ? setMostrarBotonEditar(true) : setMostrarBotonEditar(false)
    encontradoRutaBotonEliminar ? setMostrarBotonEliminar(true) : setMostrarBotonEliminar(false)
    encontradoRutaBotonUsuarioGrupo ? setMostrarBotonUsuarioGrupo(true) : setMostrarBotonUsuarioGrupo(false)
    // La operación "Reiniciar contraseña" es MASTER-ONLY en el backend: el endpoint
    // ReiniciarContrasenia exige caller con nivel 'M' (bloqueaSiCallerNoMaster → 403 si no).
    // Por eso la llave debe verse SIEMPRE para un usuario master, aunque su grupo NO tenga
    // asignado el programa S0101050000 (RutaPlana). Se mantiene además el permiso por grupo.
    ;(rol === CONST_ROL_MASTER || encontradoRutaBotonUsuarioResetearContraseña)
      ? setMostrarBotonUsuarioResetearContraseña(true)
      : setMostrarBotonUsuarioResetearContraseña(false)

    // Los setters de useState son estables; las dependencias son las mismas que en la página.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaRutasDeAcceso, rol])
  /* useEffect(() => {
    resetPassword()
  },[]) */
}
